import { useEffect, useState } from "react";
import { Search, UserCheck, X, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const CustomerPicker = ({ onPick, picked, onClear }) => {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return; }
    setLoading(true);
    const t = setTimeout(() => {
      api.get("/admin/customers/lookup", { params: { q } }).then((r) => setRows(r.data)).catch(() => setRows([])).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  if (picked) {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-[#D4AF37]/40 bg-[#D4AF37]/5 px-3 py-2.5" data-testid="nb-picked-customer">
        <UserCheck size={16} className="text-[#D4AF37] shrink-0" />
        <div className="flex-1 min-w-0 text-sm">
          <p className="text-white truncate">{picked.first_name} {picked.last_name}</p>
          <p className="text-white/50 text-xs truncate">{picked.email}{picked.phone ? ` · ${picked.phone}` : ""}</p>
        </div>
        <button type="button" onClick={onClear} className="text-white/50 hover:text-white p-1" data-testid="nb-clear-customer" aria-label="Clear customer"><X size={15} /></button>
      </div>
    );
  }

  return (
    <div className="relative" data-testid="nb-customer-picker">
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search existing customer by name, email or phone…"
        className="pl-8 bg-[#0a0a0a] border-[#D4AF37]/30" data-testid="nb-customer-search" />
      {loading && <Loader2 size={14} className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-white/40" />}
      {q.trim().length >= 2 && !loading && (
        <div className="absolute z-50 mt-1 w-full rounded-lg border border-white/15 bg-[#0d0d0d] shadow-2xl max-h-64 overflow-y-auto" data-testid="nb-customer-results">
          {rows.length === 0 && <p className="px-3 py-2.5 text-white/40 text-xs" data-testid="nb-customer-none">No match — fill in the details below to add a new customer.</p>}
          {rows.map((c, i) => (
            <button key={c.id || c.email} type="button" onClick={() => { onPick(c); setQ(""); }} data-testid={`nb-customer-option-${i}`}
              className="w-full text-left px-3 py-2 hover:bg-white/5 border-b border-white/5 last:border-0">
              <p className="text-white text-sm">{c.first_name} {c.last_name}</p>
              <p className="text-white/45 text-xs">{c.email}{c.phone ? ` · ${c.phone}` : ""}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
